import { Link } from 'wouter';
import { SEOHead } from '../components/SEOHead';
import { AppNavigationBar } from '../components/AppNavigationBar';
import { Briefcase, Plus } from 'lucide-react';

export default function AppJobs() {
  return (
    <div className="relative w-full h-screen bg-[var(--color-white)]">
      <SEOHead title="Aufträge – pixcapture.app" description="Ihre Aufträge verwalten" path="/app/jobs" />
      
      <div className="flex flex-col items-center justify-center h-full px-8">
        <Briefcase className="h-16 w-16 text-[var(--color-accent)] mb-4" />
        <h1 className="text-[24px] mb-2">Ihre Aufträge</h1>
        <p className="text-[var(--color-grey)] text-center mb-8">
          Erstellen Sie Ihren ersten Auftrag
        </p>
        <Link href="/app/job-new">
          <button className="px-6 py-3 bg-[var(--color-accent)] text-white rounded-md flex items-center gap-2">
            <Plus className="h-5 w-5" />
            Neuer Auftrag
          </button>
        </Link>
      </div>

      <AppNavigationBar activeRoute="/app/jobs" />
    </div>
  );
}
